import {lazy} from 'react';

export const TwilioCallsAsync = lazy(() =>
    import('./TwilioCallsApp')
);
